import { render } from "./Approval.vue?vue&type=template&id=6a30b2b4&ts=true"
import script from "./Approval.vue?vue&type=script&lang=ts"
export * from "./Approval.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__